import { JSONWidgetType as TeaserStandardHybridJSONWidgetType } from '@widgets/TeaserStandardHybrid'
import { JSONWidgetType as TeaserToiJSONWidgetType } from '@widgets/TeaserToi'

import {
  ExecuteQuery,
  getAureusBatchRecommendations,
  getSectionWithAureusEnvironment,
  QueryFactory,
} from '..'

export interface AureusChunkItem extends Record<string, unknown> {
  aureusOfferId: string
  articleID: string
  teasers: {
    toi: TeaserToiJSONWidgetType
    standardHybrid: TeaserStandardHybridJSONWidgetType
  }
}

export const queryKey = 'chunks'

export const createQuery = (({
  contentBlacklist,
}: {
  contentBlacklist?: string
}) =>
  ({
    [queryKey]: {
      resultsLimit: 20,
      context: {
        section: getSectionWithAureusEnvironment(`polaris-chunks`),
        purpose: 'reference',
        contentBlacklist,
      },
      recommendationLayout: {
        sectors: [
          {
            size: 5,
            minHardness: 1,
            typeSplitPercentage: {
              plus: 20,
            },
          },
          {
            size: 5,
            minHardness: 1,
            typeSplitPercentage: {
              plus: 20,
            },
          },
          {
            size: 5,
            minHardness: 1,
            typeSplitPercentage: {
              plus: 20,
            },
          },
          {
            size: 5,
            minHardness: 1,
            typeSplitPercentage: {
              plus: 20,
            },
          },
        ],
      },
    },
  }) as const) satisfies QueryFactory<typeof queryKey>

export const executeQuery = (async (
  queryOptions: Parameters<typeof createQuery>[0],
  options?: Record<string, unknown>,
) => {
  try {
    const result = (
      await getAureusBatchRecommendations<typeof queryKey, AureusChunkItem>(
        createQuery(queryOptions),
        options,
      )
    ).results[queryKey]

    if (!Array.isArray(result?.recommendations)) {
      return
    }

    return result.recommendations
  } catch (err) {
    console.error(err)
  }
}) satisfies ExecuteQuery<typeof queryKey>
